import React from 'react';

const RULES = [
  { icon: '1', title: 'No Harassment or Bullying', desc: 'Treat everyone with respect. No targeted harassment, threats, intimidation, or bullying of any kind.' },
  { icon: '2', title: 'No Hate Speech or Discrimination', desc: 'No content that promotes hatred based on race, ethnicity, gender, religion, sexual orientation, disability, or any other protected characteristic.' },
  { icon: '3', title: 'No Sexual or Suggestive Content', desc: 'No sexually explicit, suggestive, or provocative content. This includes revealing clothing worn to attract attention, suggestive poses or behavior, sexual audio content, and any content designed to sexualize the streamer. Ninty is not that kind of platform.' },
  { icon: '4', title: 'Dress Code', desc: 'Streamers must wear appropriate clothing at all times. No swimwear, underwear, or excessively revealing outfits. If you wouldn\'t wear it to a casual workplace, don\'t wear it on stream. This applies to all genders equally.' },
  { icon: '5', title: 'No Violence or Self-Harm', desc: 'No content that glorifies violence, gore, or self-harm. If you or someone you know needs help, please reach out to a crisis line.' },
  { icon: '6', title: 'No Spam or Scams', desc: 'No spamming chat, promoting scams, phishing links, or deceptive content designed to mislead others.' },
  { icon: '7', title: 'No Impersonation', desc: 'Do not impersonate other users, streamers, public figures, or Ninty staff.' },
  { icon: '8', title: 'No Doxxing', desc: 'Never share personal information of others without their consent. This includes real names, addresses, phone numbers, or any private info.' },
  { icon: '9', title: 'No Illegal Activity', desc: 'Do not stream, promote, or engage in any illegal activity. This includes drug use, underage drinking, and illegal gambling.' },
  { icon: '10', title: 'Respect Copyright', desc: 'Do not restream, rebroadcast, or use copyrighted content (music, movies, other streams) without permission.' },
  { icon: '11', title: 'Age Requirement', desc: 'You must be at least 13 years old to use Ninty. Users under 18 should have parental consent.' },
];

const ENFORCEMENT = [
  { action: 'Warning', desc: 'First-time or minor violations may result in a warning sent to your account.' },
  { action: 'Temporary Suspension', desc: 'Repeated or moderate violations may result in a temporary suspension (24 hours to 30 days).' },
  { action: 'Permanent Ban', desc: 'Severe violations or repeated offenses will result in a permanent account ban.' },
  { action: 'Stream Termination', desc: 'Active streams violating guidelines will be ended immediately.' },
];

export default function GuidelinesPage() {
  return (
    <div className="dashboard">
      <h1>Community Guidelines</h1>

      <div className="stream-setup">
        <p style={{ fontSize: '0.95rem', color: '#adadb8', marginBottom: '20px', lineHeight: 1.6 }}>
          Ninty is a community for creators and viewers to connect, share, and have fun. To keep this a safe and welcoming space for everyone, all users must follow these guidelines.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {RULES.map(rule => (
            <div key={rule.icon} style={{ display: 'flex', gap: '14px', padding: '16px', background: '#0e0e10', borderRadius: '4px', border: '1px solid #2a2a2e' }}>
              <div style={{ fontFamily: 'var(--font-pixel)', fontSize: '0.7rem', color: 'var(--accent)', width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#18181b', borderRadius: '2px', flexShrink: 0, boxShadow: '2px 2px 0 rgba(0,0,0,0.3)' }}>
                {rule.icon}
              </div>
              <div>
                <div style={{ fontWeight: 800, fontSize: '0.95rem', marginBottom: '4px' }}>{rule.title}</div>
                <div style={{ fontSize: '0.85rem', color: '#adadb8', lineHeight: 1.5 }}>{rule.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="stream-setup">
        <h2>Enforcement</h2>
        <p style={{ fontSize: '0.85rem', color: '#adadb8', marginBottom: '16px' }}>
          Violations are reviewed by our moderation team. Actions are based on severity and history:
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {ENFORCEMENT.map(e => (
            <div key={e.action} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
              <span style={{ fontWeight: 800, fontSize: '0.85rem', color: e.action === 'Permanent Ban' ? '#eb0400' : e.action === 'Temporary Suspension' ? '#ffa726' : 'var(--accent)', minWidth: '160px', flexShrink: 0 }}>
                {e.action}
              </span>
              <span style={{ fontSize: '0.85rem', color: '#adadb8' }}>{e.desc}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="stream-setup">
        <h2>Reporting</h2>
        <p style={{ fontSize: '0.85rem', color: '#adadb8', lineHeight: 1.6 }}>
          If you see content or behavior that violates these guidelines, please use the report button on any user's profile or stream page. All reports are reviewed by our team and handled confidentially. False or abusive reports may result in action against the reporter.
        </p>
      </div>
    </div>
  );
}
